export default __webpack_public_path__ + "static/media/lib-9.949389ed.webp";